import React,{ Component } from 'react';
import transLoader from '@beisen/i18n-translation-loader';
require('./loading.scss');

const defaultTranslation = {
  loadingTip: '提交中，请稍等...'
};

class SubLoading extends Component {
  constructor(props) {
    super(props);
    this.translation = Object.assign({}, defaultTranslation, transLoader({
        loadingTip: 'common.loadingTip'
    }), props.translation);
  }
  render() {
    const { translation } = this;
    return (
      <div className="load_content">
        <div className="load_father">
        <div className="load_sub">
          <div className="load_sub_pic">
          </div>
          <div className="load_sub_wait">{translation.loadingTip}</div>
        </div>
      </div>
      </div>
    );
  }
}
export default SubLoading;






// WEBPACK FOOTER //
// ./src/components/Form/SubLoading/loading.js